import React, { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";
import { otpConfirmation } from "../store/slices/auth";

export default function OTPVerify() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isSignupFlow = Boolean(
    location.state?.email || location.state?.mobileNumber,
  );

  const isLoginFlow = Boolean(location.state?.uname);

  useEffect(() => {
    if (!isSignupFlow && !isLoginFlow) {
      navigate("/login");
    }
  }, [isSignupFlow, isLoginFlow, navigate]);

  let displayTarget = "";

  if (isSignupFlow) {
    displayTarget = location.state?.email || location.state?.mobileNumber;
  } else if (isLoginFlow) {
    displayTarget = location.state?.uname;
  }

  const { loading, error } = useSelector((state) => state.auth);

  const [otp, setOtp] = useState("");

  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    let t;
    if (timer > 0) {
      t = setTimeout(() => setTimer((prev) => prev - 1), 1000);
    } else {
      setCanResend(true);
    }
    return () => clearTimeout(t);
  }, [timer]);

  const handleVerify = () => {
    if (!otp.trim()) {
      alert("Please enter OTP");
      return;
    }

    const payload = isSignupFlow
      ? {
          email: location.state?.email || "",
          mobileNumber: location.state?.mobileNumber || "",
          otp,
        }
      : {
          email: location.state.uname.includes("@") ? location.state.uname : "",
          mobileNumber: location.state.uname.includes("@")
            ? ""
            : location.state.uname,
          otp,
        };

    dispatch(otpConfirmation(payload))
      .unwrap()
      .then(() => {
        //  cleanup temporary login storage
        sessionStorage.removeItem("otp_uname");
        sessionStorage.removeItem("otp_signup_email");
        sessionStorage.removeItem("otp_signup_mobile");

        navigate("/");
      })
      .catch((err) => {
        alert(err || "OTP verification failed");
      });
  };

  /* =====================================================
     UI
  ===================================================== */

  return (
    <>
      <Navbarsticky />
      <div className="auth-container"></div>

      <div className="container d-flex justify-content-center mt-5">
        <div
          className="card p-3 shadow"
          style={{
            maxWidth: "400px",
            width: "100%",
            marginTop: "5rem",
            marginBottom: "5rem",
          }}
        >
          <h4 className="text-center mb-3">OTP Verification</h4>

          <p className="text-center text-muted" style={{ fontSize: "14px" }}>
            OTP sent to <b>{displayTarget}</b>
          </p>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            maxLength={6}
          />

          <Button
            className="w-100 mb-3"
            onClick={handleVerify}
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : "Verify OTP"}
          </Button>

          {!canResend ? (
            <p className="text-center text-muted">
              Resend OTP in <b>{timer}s</b>
            </p>
          ) : (
            <p className="text-center">
              <Button variant="link">Resend OTP</Button>
            </p>
          )}

          {error && <p className="text-danger text-center mt-2">{error}</p>}
        </div>
      </div>

      <Footer />
    </>
  );
}
